export default __webpack_public_path__ + "static/media/feather _ chevron-right.e4b245de.svg";